/* =============================================================
   Acaure — Interacciones de tienda
   · Carrito real vía Cart AJAX API (add/change)
   · Botón + / stepper en las cards
   · Carrusel de fotos por card
   · Burbuja del header + evento global "acaure:cart:update"
   ============================================================= */
(function () {
  "use strict";

  var SVG_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var SVG_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  var busy = false;

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function addItem(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: qty })
    });
  }
  function changeItem(id, qty) {
    // /cart/change.js exige el `id` como STRING (variant id `\d+` o line key
    // `\d+:hash`). Un id numérico devuelve HTTP 400 y la cantidad no cambia
    // —por eso +/- quedaban muertos en catálogo y carrito tras el primer add
    // (add.js sí acepta numérico). Stringificar aquí cubre ambos flujos.
    return fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: String(id), quantity: qty })
    });
  }

  function renderZone(zone, qty) {
    /* Las cards agotadas ya no renderizan add-zone, pero por si alguna vez
       vuelven a tener una: jamás pintarle controles a un producto agotado. */
    if (zone.closest(".t3-card.is-soldout")) return;
    if (qty > 0) {
      zone.innerHTML =
        '<div class="t3-stepper" data-stepper>' +
          '<button type="button" data-dec aria-label="Quitar uno">' + SVG_MINUS + "</button>" +
          '<span class="t3-qty" data-qty aria-live="polite">' + qty + "</span>" +
          '<button type="button" data-inc aria-label="Agregar uno">' + SVG_PLUS + "</button>" +
        "</div>";
    } else {
      zone.innerHTML = '<button class="t3-add" type="button" data-add aria-label="Agregar">' + SVG_PLUS + "</button>";
    }
  }

  function updateBubble(count) {
    var link = document.getElementById("cart-icon-bubble");
    if (!link) return;
    var bubble = link.querySelector(".cart-count-bubble");
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement("div");
        bubble.className = "cart-count-bubble";
        link.appendChild(bubble);
      }
      bubble.innerHTML = '<span aria-hidden="true">' + count + "</span>";
    } else if (bubble) {
      bubble.remove();
    }
  }

  function syncZones(cart) {
    var q = {};
    (cart.items || []).forEach(function (it) { q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
    document.querySelectorAll("[data-add-zone]").forEach(function (zone) {
      var vid = Number(zone.getAttribute("data-variant-id"));
      renderZone(zone, q[vid] || 0);
    });
  }

  function refresh() {
    return getCart().then(function (cart) {
      syncZones(cart);
      updateBubble(cart.item_count);
      document.dispatchEvent(new CustomEvent("acaure:cart:update", { detail: cart }));
      return cart;
    });
  }

  function mutate(promiseFn) {
    if (busy) return;
    busy = true;
    Promise.resolve(promiseFn())
      .then(function () { return refresh(); })
      .catch(function (e) { if (window.console) console.warn("Acaure cart:", e); })
      .then(function () { busy = false; });
  }

  /* ---- Clicks en + / stepper ---- */
  document.addEventListener("click", function (e) {
    var addBtn = e.target.closest("[data-add]");
    var inc = e.target.closest("[data-inc]");
    var dec = e.target.closest("[data-dec]");
    if (!addBtn && !inc && !dec) return;
    var zone = e.target.closest("[data-add-zone]");
    if (!zone) return;
    e.preventDefault();
    var vid = Number(zone.getAttribute("data-variant-id"));
    if (!vid) return;
    if (addBtn) {
      mutate(function () { return addItem(vid, 1); });
    } else {
      var span = zone.querySelector("[data-qty]");
      var cur = parseInt(span && span.textContent, 10) || 0;
      var next = inc ? cur + 1 : cur - 1;
      mutate(function () { return changeItem(vid, Math.max(0, next)); });
    }
  });

  /* ---- PDP: selector de cantidad, agregar y galería ---- */
  document.addEventListener("click", function (e) {
    var qd = e.target.closest("[data-q-dec]");
    var qi = e.target.closest("[data-q-inc]");
    var padd = e.target.closest("[data-pdp-add]");
    var thumb = e.target.closest("[data-pp-thumb]");
    if (qd || qi) {
      var box = e.target.closest("[data-pdp-qty]");
      if (!box) return;
      var val = box.querySelector(".val");
      var cur = parseInt(val.textContent, 10) || 1;
      val.textContent = Math.min(99, Math.max(1, qi ? cur + 1 : cur - 1));
    } else if (padd) {
      e.preventDefault();
      if (padd.disabled) return;
      var vid = Number(padd.getAttribute("data-variant-id"));
      if (!vid) return;
      var qbox = document.querySelector("[data-pdp-qty] .val");
      var qty = parseInt(qbox && qbox.textContent, 10) || 1;
      var label = padd.textContent.trim();
      padd.disabled = true; padd.textContent = "Agregado ✓";
      Promise.resolve(addItem(vid, qty)).then(refresh).then(function () {
        setTimeout(function () { padd.textContent = label; padd.disabled = false; }, 1400);
      }).catch(function () { padd.textContent = label; padd.disabled = false; });
    } else if (thumb) {
      var main = document.getElementById("ppMainPhoto");
      if (main) main.src = thumb.getAttribute("data-src");
      document.querySelectorAll("[data-pp-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
    }
  });

  /* ---- Carrusel de fotos por card ---- */
  function wireScroller(card) {
    var scroller = card.querySelector(".t3-scroller");
    if (!scroller) return;
    var slides = scroller.querySelectorAll(".t3-slide");
    var dots = card.querySelectorAll(".t3-dot");
    var prev = card.querySelector(".t3-prev");
    var next = card.querySelector(".t3-next");
    if (slides.length < 2) return;
    var idx = 0, raf = null, dragX = null;
    function update() { for (var i = 0; i < dots.length; i++) dots[i].classList.toggle("is-active", i === idx); }
    function goTo(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      if (slides[idx]) scroller.scrollTo({ left: slides[idx].offsetLeft, behavior: "smooth" });
      update();
    }
    scroller.addEventListener("scroll", function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = scroller.clientWidth;
        var ni = Math.round(scroller.scrollLeft / w);
        if (ni !== idx) { idx = ni; update(); }
      });
    }, { passive: true });
    if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); goTo(idx - 1); });
    if (next) next.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); goTo(idx + 1); });
    scroller.addEventListener("pointerdown", function (e) { dragX = e.clientX; });
    var link = card.querySelector(".t3-card-link");
    if (link) link.addEventListener("click", function (e) {
      if (dragX !== null && Math.abs((e.clientX || 0) - dragX) > 6) e.preventDefault();
      dragX = null;
    });
  }

  function init() {
    document.querySelectorAll(".t3-card").forEach(wireScroller);
    // Sincroniza steppers/burbuja con el carrito real al cargar
    refresh();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---- Barra inferior "Ver mi pedido" ---- */
  function formatMoney(cents) {
    var fmt = window.AcaureMoneyFormat || "${{amount}}";
    var v = (Math.round(cents) / 100).toFixed(2);
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, v.split(".")[0]);
  }
  function updateBar(cart) {
    var bar = document.getElementById("acaureCartBar");
    if (!bar) return;
    var count = cart.item_count || 0;
    var kg = (cart.total_weight || 0) / 1000;
    var elCount = bar.querySelector("[data-cb-count]");
    var elWeight = bar.querySelector("[data-cb-weight]");
    var elTotal = bar.querySelector("[data-cb-total]");
    if (elCount) elCount.textContent = count + (count === 1 ? " paquete" : " paquetes");
    if (elWeight) elWeight.innerHTML = (kg > 0 ? kg.toFixed(1).replace(".", ",") : "0") + ' kg <span class="cb-aprox">aprox</span>';
    if (elTotal) elTotal.innerHTML = formatMoney(cart.total_price || 0);
    if (count > 0) { bar.classList.add("is-visible"); bar.setAttribute("aria-hidden", "false"); document.body.classList.add("ac-has-cartbar"); }
    else { bar.classList.remove("is-visible"); bar.setAttribute("aria-hidden", "true"); document.body.classList.remove("ac-has-cartbar"); }
  }
  document.addEventListener("acaure:cart:update", function (e) { updateBar(e.detail); });

  window.AcaureShop = {
    refresh: refresh,
    getCart: getCart,
    formatMoney: formatMoney,
    setQty: function (id, qty) { return changeItem(id, Math.max(0, qty)).then(refresh); }
  };
})();
